import RegisterComponent from "../components/Auth/RegisterComponent";

export default function RegisterPage (){

    return (
        <>
        <RegisterComponent/>
        </>
    )
}